"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { useConsent } from "@/components/lgpd/consent-store";
import { getOrCreateSessionId, detectDevice, shouldTrack } from "@/lib/analytics-client";

export function AnalyticsBeacon() {
  const pathname = usePathname();
  const { preferences, hydrated } = useConsent();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (!hydrated) return;
    if (!shouldTrack(preferences.analytics)) return;
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;

    const payload = JSON.stringify({
      path: pathname,
      title: document.title,
      referrer: document.referrer || null,
      device: detectDevice(),
      sessionId: getOrCreateSessionId(),
    });

    if (typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon("/api/analytics/pageview", new Blob([payload], { type: "application/json" }));
    } else {
      fetch("/api/analytics/pageview", { method: "POST", body: payload, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
    }
  }, [pathname, preferences.analytics, hydrated]);

  return null;
}
